"use client";

import Image from "next/image";
import { HeroImageProps } from "./types";

export default function HeroImage({
  backgroundImage,
  benefits,
}: HeroImageProps) {
  return (
    <div className="relative flex min-h-[245px] w-full items-center sm:min-h-[375px] lg:min-h-[245px] lg:w-1/2">
      <Image
        src={backgroundImage}
        alt=""
        priority
        loading="eager"
        fetchPriority="high"
        fill
        className="object-cover object-center"
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
      />
    </div>
  );
}
